import React from 'react'

import { SpicyChiliSVG } from '@src/components/SVGS/SpicyChiliSVG'

interface SpiceLevelProps {
  level: number
}

export const SpiceLevel: React.FC<SpiceLevelProps> = ({ level }) => {
  if (level <= 0) return null
  const width = window.innerWidth
  return (
    <>
      {Array.from({ length: level }).map((_, index) => (
        <SpicyChiliSVG
          width={width >= 744 ? 20 : 14}
          height={width >= 744 ? 20 : 14}
          key={index}
        />
      ))}
    </>
  )
}
